import { useEffect } from 'react';
import spaceProfileDefaults, { setDefaults } from './defaults';
import axios from '../../utils/axios';

const useSpaceProfile = (
  companyName,
  guid,
  propertyName,
  setSpaceProfile,
  setErrors,
  setAssets,
  setFloorData,
  setSpaceProfilePhotos,
  setFieldSettings,
  setSpacePages,
  setGeneralSettings,
  setAssetGuid,
  setDisplayAddress,
  setSpaceAssignment
) => {
  useEffect(() => {
    // TODO: Cache this if coming from the entry form
    async function fetchProfile() {
      const result = await axios.get(`/space-profiles/${guid}`);

      if (result.status === 200) {
        const data = result.data.record;
        setDefaults(spaceProfileDefaults, data);
        setSpaceProfile(data);
        if (setFloorData) setFloorData(result.data.floors);
        if (setFieldSettings) setFieldSettings(result.data.settings && result.data.settings.fieldSettings);
        if (setGeneralSettings) setGeneralSettings(result.data.settings.generalSettings);
        if (setAssetGuid) setAssetGuid(data.asset_guid);
        if (data.asset_guid && setSpaceAssignment) {
          try {
            const space = await axios.get(`/spaces/asset-guid/${data.asset_guid}`, 
              {params: { company: data.company, property: data.property }});
            if (space) setSpaceAssignment(space.data.record[0]);
          } catch (e) {
            setErrors(`There was an error: ${result.errors}`);
          }
        }
      } else {
        setErrors(`There was an error: ${result.errors}`);
      }
    }

    async function fetchAssets() {
      const result = await axios.get(`/space-profile-assets?spaceProfileGuid=${guid}`);

      if (result.status === 200) {
        const data = result.data.records;
        setAssets(data);
      } else {
        setErrors(`There was an error: ${result.errors}`);
      }
    }

    async function fetchPhotos() {
      const result = await axios.get(`/space-profiles/${guid}/files`);

      if (result.status === 200) {
        const data = result.data.record;
        setSpaceProfilePhotos(data);
      } else {
        setErrors(`There was an error: ${result.errors}`);
      }
    }

    if (!guid) return;
    fetchProfile();
    if (setAssets) fetchAssets();
    if (setSpaceProfilePhotos) fetchPhotos();
  }, [guid, setAssets, setErrors, setFieldSettings, setFloorData, setSpaceProfile, setGeneralSettings, setDisplayAddress, setAssetGuid, setSpaceProfilePhotos, companyName, setSpaceAssignment, propertyName]);

  useEffect(() => {
    async function fetchPages() {
      const result = await axios.get(`/pages/${companyName}/${propertyName}`);

      if (result.status === 200) {
        const data = result.data.data;
        setSpacePages(data);
      } else {
        setErrors(`There was an error: ${result.errors}`);
      }
    };

    if (companyName && propertyName && setSpacePages) {
      fetchPages();
    }
  }, [companyName, propertyName, setSpacePages, setErrors])
};

export { useSpaceProfile };
